export const pacsdataTableHeader = [
  "Name",
  "AE Title",
  "Port",
  "Time Zone",
  "IP Address",
  "Priority",
];
export const platformTableHeader = [
  "Name",
  "IP Address",
  "RPC URL",
  "Dataset ID",
  "Platform Username",
];
export const FilterTableHeader = ["Filter Name", "Filter"];
export const FetchStudyHeaders = [
  "Identifier Type",
  "Unique Identifier",
  "Patient Name",
  "Patient ID",
  "Instances",
  "Router Configuration",
  "Status",
];

export const FetchServiceAccountHeaders = ["Unique Identifier", "Platform URL"];
